import * as Auth from '../constants/auth.constant'
import { FluxStandardAction } from 'flux-standard-action'

export const inputer = (data: any): FluxStandardAction<any, any> => {
  return {
    type: Auth.INPUTER_TEST,
    payload: data,
    meta: null,
  }
}

export const signIn = (data: {
  username: string
  password: string
}): FluxStandardAction<any, any> => {
  return {
    type: Auth.PROCESS_SIGN_IN,
    payload: data,
    meta: null,
  }
}

export const signOut = (): FluxStandardAction<any, any> => {
  return {
    type: Auth.PROCESS_SIGN_OUT,
    payload: {},
    meta: null,
  }
}
export const getSession = (): FluxStandardAction<any, any> => {
  return {
    type: Auth.PROCESS_GET_SESSION,
    payload: {},
    meta: null,
  }
}



// WEBPACK FOOTER //
// ./src/actions/auth.action.ts